<app-breadcrumb [title]="'Actualizar Pólizas'" [items]="['Vehiculos']" [active_item]="'Actualizar Pólizas'"></app-breadcrumb>

<div class="container d-flex my-4">
    <!-- Línea vertical verde oscuro -->
    <div class="border-start border-5 border-success"></div>
    
    <!-- Contenedor de alerta con fondo verde oscuro, sin bordes -->
    <div class="alert bg-success text-white flex-grow-1 p-3 mb-0 border-0">
      <div class="d-flex">
        <div class="me-3">
          <h5 class="mb-0" style="font-size: 1.25rem;">Importante!</h5>
          <p class="mb-0">Solo se actualizaran las FECHAS de los vehículos que tengan la relación de AFILIADOS.</p>
        </div>
      </div>
    </div>
  </div>
  
  

<div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-verification-check me-2"></i>
      <h5 class="mb-0">Actualizar Pólizas</h5>
    </div>
    <div class="card-body">

      <div class="row g-3">

        <form [formGroup]="formExtracontractual" class="d-flex gap-3">
          <div class="col-md-3 mb-3">
            <label class="form-label" for="fechaExpedicionExtra">FECHA INICIAL RCE</label>
            <div class="input-group input-group-sm">
              <input id="fechaExpedicionExtra" type="date"
                     class="form-control form-control-lg fs-14"
                     formControlName="fecha_expedicionRCE"/>
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <label class="form-label" for="fechaVencimientoExtra">FECHA FINAL RCE</label>
            <div class="input-group input-group-sm">
              <input id="fechaVencimientoExtra" type="date"
                     class="form-control form-control-lg fs-14"
                     formControlName="fecha_vencimientoRCE"/>
            </div>
          </div>
        </form>
      
        <form [formGroup]="formContractual" class="d-flex gap-3">
          <div class="col-md-3 mb-3">
            <label class="form-label" for="fechaExpedicion">FECHA INICIAL RCC</label>
            <div class="input-group input-group-sm">
              <input id="fechaExpedicion" type="date"
                     class="form-control form-control-lg fs-14"
                     formControlName="fecha_expedicionRCC"/>
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <label class="form-label" for="fechaVencimiento">FECHA FINAL RCC</label>
            <div class="input-group input-group-sm">
              <input id="fechaVencimiento" type="date"
                     class="form-control form-control-lg fs-14"
                     formControlName="fecha_vencimientoRCC"/>
            </div>
          </div>
        </form>
      
      </div>
      
      
      
        <div class="d-flex justify-content-center gap-3 mt-3">
          <button class="btn btn-success" type="button" (click)="actualizarTodosLosHistoriales()">
            <app-feather-icons [icon]="'refresh-ccw'" class="me-2"></app-feather-icons>
            <span>Actualizar</span>
          </button>
          
  
        </div>

    </div>
  </div>
  